// import { Button, Grid, Typography, TextField, Box, Hidden } from "@mui/material";
// import { Search as IconSearch } from "@mui/icons-material";
// import api from "../../services/api";
// import { useDispatch, useSelector } from 'react-redux';
// import { useEffect, useState } from "react";
// import moment from "moment";
// import { Link, useNavigate } from "react-router-dom";
// import { setValue } from '../../redux/personSearchSlice';
// import DataGridBase from "../../components/common/DataGridBase"

// const Index = () => {
//     const filters = useSelector((state) => state.personSearch.filters);
//     const [cargando, setCargando] = useState(true);
//     const [results, setResults] = useState([]);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     useEffect(() => {
//         api.get('/Persona/GetPersonasResumenView')
//             .then(function (response) {
//                 setResults(response.data.data);
//                 setCargando(false);
//             })
//             .catch(function (error) {
//                 console.log(error);
//             });
//     }, [])

//     const fetchResults = async () => {
//         setCargando(true);

//         await api
//             .get('/Persona/GetPersonasResumenViewByNumeroDocumentoYNombres?numeroDocumento=' + (filters.numeroDocumento == null ? "" : filters.numeroDocumento) + '&nombres=' + (filters.nombres == null ? "" : filters.nombres))
//             .then((response) => {
//                 setResults(response.data.data);
//                 setCargando(false);
//             })
//             .catch((err) => {
//                 console.log("Err: ", err)
//             });
//     }

//     const columns = [
//         // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
//         { field: 'nombres', headerName: 'Nombres', width: 200, sortable: false, headerAlign: 'center'
//             , renderCell: (cellValues) => {
//                 return <Link to={'/person/edit/' + cellValues.row.id + '/0/0'} style={{ color: 'inherit' }}>{cellValues.row.nombres}</Link>;
//             }
//         },
//         { field: 'tipoDocumento', headerName: 'Tipo Doc', width: 100, sortable: false, headerAlign: 'center' },
//         { field: 'numeroDocumento', headerName: 'Nro Doc', width: 120, sortable: false, headerAlign: 'center' },
//         { field: 'tipoPersona', headerName: 'Tipo Per', width: 120, sortable: false, headerAlign: 'center' },
//         { field: 'fechaNacimiento', headerName: 'Nacimiento', width: 120, type: 'date'
//             , valueFormatter: (params) => moment(params).format('D/MM/YYYY')
//             , sortable: true, headerAlign: 'center', align: 'center' },
//         { field: 'celular', headerName: 'Celular', width: 120, sortable: false, headerAlign: 'center' },
//         { field: 'email', headerName: 'Email', width: 120, sortable: false, headerAlign: 'center' },
//         { field: 'empresa', headerName: 'Empresa', width: 30, sortable: false, headerAlign: 'center' },
//     ];

//     return (
//         <div>
//             <Grid container>
//                 <Grid item>
//                     <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                         Personas
//                     </Typography>
//                 </Grid>
//                 <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
//                     <Grid item>
//                         <Grid container item xs={12} sm={12} spacing={1}>
//                             <Grid item xs={7} sm={4}>
//                                 <TextField
//                                     name="numeroDocumento"
//                                     label="Numero Documento"
//                                     value={filters.numeroDocumento}
//                                     fullWidth
//                                     onChange={(event) => {
//                                         dispatch(setValue({name: "numeroDocumento", value: event.target.value}))
//                                     }}
//                                     onKeyDown={(event) => {
//                                         if (event.key === "Enter") {
//                                             event.preventDefault();
//                                             fetchResults();
//                                         }
//                                     }}
//                                     size="small"
//                                 />
//                             </Grid>
//                             <Grid item xs={9} sm={6}>
//                                 <TextField
//                                     name="nombres"
//                                     label="Nombres"
//                                     value={filters.nombres}
//                                     fullWidth
//                                     onChange={(event) => {
//                                         dispatch(setValue({name: "nombres", value: event.target.value}))
//                                     }}
//                                     onKeyDown={(event) => {
//                                         if (event.key === "Enter") {
//                                             event.preventDefault();
//                                             fetchResults();
//                                         }
//                                     }}
//                                     size="small"
//                                 />
//                             </Grid>
//                             <Grid item xs={3} sm={2} display={"flex"} alignItems={"center"}>
//                                 <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
//                                     {<Hidden smDown></Hidden>}
//                                     <IconSearch />
//                                 </Button>
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                     <Grid item>
//                         <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
//                             <DataGridBase
//                                 rows={results}
//                                 columns={columns}
//                                 loading={cargando}
//                                 onNewClick={() => navigate(`/person/edit/0/0/0`)}
//                             />
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Grid>
//         </div>
//     )
// }
// export default Index

import { Button, Grid, Typography, TextField, Box, Hidden, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Search as IconSearch, PersonAdd as IconPersonAdd, AddBusiness as IconAddBusiness } from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setResults } from '../../redux/person/personSearchSlice';
import DataGridBase from "../../components/common/DataGridBase"
import * as personaService from "../../services/personaService"

const Index = () => {
    const filters = useSelector((state) => state.personSearch.filters);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        fetchResults()
    }, [])

    const fetchResults = async () => {
        setCargando(true);
        const response = await personaService.getsPersonasResumenViewByNumeroDocumentoYNombres(
            filters.numeroDocumento ?? "",
            filters.nombres ?? "",
            filters.empresa ?? "",
            filters.tipoPersonaEntidad ?? 1,)
        setResults(response)
        setCargando(false);
    }

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'nombres', headerName: 'Nombres', width: 300, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                // return <Link to={'/person/edit/' + cellValues.row.id + '/0/0'} style={{ color: 'inherit' }}>{cellValues.row.nombres}</Link>;
                const url =
                    cellValues.row.esEmpresa === true
                        ? `/person/editLegal/${cellValues.row.id}`
                        : `/person/edit/${cellValues.row.id}/0/0`;

                return (
                    <Link
                        to={url}
                        style={{ color: 'inherit' }}
                    >
                        {cellValues.row.nombres}
                    </Link>
                );
            }
        },
        { field: 'tipoDocumento', headerName: 'Tipo Doc', width: 100, sortable: false, headerAlign: 'center' },
        { field: 'numeroDocumento', headerName: 'Nro Doc', width: 120, sortable: false, headerAlign: 'center' },
        // { field: 'tipoPersona', headerName: 'Tipo Per', width: 120, sortable: false, headerAlign: 'center' },
        // { field: 'fechaNacimiento', headerName: 'Nacimiento', width: 120, type: 'date'
        //     , valueFormatter: (params) => moment(params).format('D/MM/YYYY')
        //     , sortable: true, headerAlign: 'center', align: 'center' },
        { field: 'celular', headerName: 'Celular', width: 120, sortable: false, headerAlign: 'center' },
        { field: 'email', headerName: 'Email', width: 120, sortable: false, headerAlign: 'center' },
        { field: 'fechaRegistro', headerName: 'Registro', width: 120, type: 'date'
            , valueFormatter: (params) => moment(params).format('D/MM/YYYY')
            , sortable: true, headerAlign: 'center', align: 'center' },
        { field: 'empresa', headerName: 'Empresa', width: 30, sortable: false, headerAlign: 'center' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Personas
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={7} sm={4}>
                                <TextField
                                    name="numeroDocumento"
                                    label="Numero Documento"
                                    value={filters.numeroDocumento}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "numeroDocumento", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={9} sm={4}>
                                <TextField
                                    name="nombres"
                                    label="Nombres"
                                    value={filters.nombres}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "nombres", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Empresa</InputLabel>
                                    <Select label="Empresa" value={filters.empresa ?? ""}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "empresa", value: event.target.value}));
                                        }}
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        <MenuItem value="S">Sí</MenuItem>
                                        <MenuItem value="N">No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* Colegios, bancos y demas personas juridicas de tipo entidad
                                no se listan junto a los clientes, familiares, proveedores
                                y trabajadores: se piden con este filtro. */}
                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Tipo Persona Entidad</InputLabel>
                                    <Select label="Tipo Persona Entidad" value={filters.tipoPersonaEntidad ?? 1}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "tipoPersonaEntidad", value: parseInt(event.target.value)}));
                                        }}
                                    >
                                        <MenuItem value={1}>No (Personas)</MenuItem>
                                        <MenuItem value={2}>Sí (Entidades)</MenuItem>
                                        <MenuItem value={0}>Todos</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                toolbarButtons={[
                                    {
                                        text: "Particular",
                                        icon: <IconPersonAdd />,
                                        onClick: () => navigate("/person/edit/0/0/0")
                                    },
                                    {
                                        text: "Empresa",
                                        icon: <IconAddBusiness />,
                                        onClick: () => navigate("/person/editLegal/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index



